module.exports = __webpack_public_path__ + "images/般蓝pr长图_02.jpg?v=6f31ecc6";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_02.jpg
 ** module id = 179
 ** module chunks = 1 2
 **/